import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Exams Under Review|Review Tool|Exam Sections|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSecurity,
	portal: 'SP',
};

type LocNameStart = 'SPReviewToolExamSections';
export type SPReviewToolExamSectionsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ContentUnknown`
	| `${LocNameStart}LabelOridinal`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelTitle`
	| `${LocNameStart}LabelGrade`
	| `${LocNameStart}LabelScored`
	| `${LocNameStart}LabelAlgorithm`
	| `${LocNameStart}LabelScore`
	| `${LocNameStart}LabelMastery`
	| `${LocNameStart}LabelCorrect`
	| `${LocNameStart}LabelIncorrect`
	| `${LocNameStart}LabelSkipped`;

export const spReviewToolExamSectionsLocs: LocDefs<SPReviewToolExamSectionsLocNames> = {
	SPReviewToolExamSectionsTitleSection: {
		defaultValue: 'Section Details',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Title.SectionDetailsSection',
		...sharedProperties,
	},
	SPReviewToolExamSectionsContentUnknown: {
		defaultValue: 'Unknown',
		description: 'Text for unkown ordinal.',
		displayPath: `${pathStart}Unknown ordinal`,
		displayType: 'Content',
		legacyName: 'Exam/CandidateExamSection.Content.OrdinalUnknown',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelOridinal: {
		defaultValue: 'ID',
		description: 'Column heading for: ID.',
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Id',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Name',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelTitle: {
		defaultValue: 'Title',
		description: 'Column heading for: Title.',
		displayPath: `${pathStart}Title`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Title',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelGrade: {
		defaultValue: 'Grade',
		description: 'Column heading for: Grade.',
		displayPath: `${pathStart}Grade`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Grade',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelScored: {
		defaultValue: 'Scored',
		description: 'Column heading for: Scored.',
		displayPath: `${pathStart}Scored`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Scored',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelAlgorithm: {
		defaultValue: 'Algorithm',
		description: 'Column heading for: Algorithm.',
		displayPath: `${pathStart}Algorithm`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ScoringAlgorithm',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelScore: {
		defaultValue: 'Score',
		description: 'Column heading for: Score.',
		displayPath: `${pathStart}Score`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.Score',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelMastery: {
		defaultValue: 'Mastery',
		description: 'Column heading for: Mastery.',
		displayPath: `${pathStart}Mastery`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.MasteryScore',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelCorrect: {
		defaultValue: 'Correct',
		description: 'Column heading for: Correct.',
		displayPath: `${pathStart}Correct`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ItemsCorrect',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelIncorrect: {
		defaultValue: 'Incorrect',
		description: 'Column heading for: Incorrect.',
		displayPath: `${pathStart}Incorrect`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ItemsIncorrect',
		...sharedProperties,
	},
	SPReviewToolExamSectionsLabelSkipped: {
		defaultValue: 'Skipped',
		description: 'Column heading for: Skipped.',
		displayPath: `${pathStart}Skipped`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.ColumnHeading.ItemsSkipped',
		...sharedProperties,
	},
};

export type SPReviewToolExamSectionsLocType = LocMap<SPReviewToolExamSectionsLocNames>;
